import { render, staticRenderFns } from "./lhc_home_table.vue?vue&type=template&id=63b8928b&scoped=true"
import script from "./lhc_home_table.vue?vue&type=script&lang=js"
export * from "./lhc_home_table.vue?vue&type=script&lang=js"
import style0 from "./lhc_home_table.vue?vue&type=style&index=0&id=63b8928b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b8928b",
  null
  
)

export default component.exports